import React from "react";
import {useTranslation} from 'react-i18next';


const InvoiceChooseUsSection = () =>{
    const {t} = useTranslation('invoicepage');
    return(
        <section className="invoice-choose-section section-container">
            <div className="invoice-choose-us-section">
                <div className="invoice-choose-us-section-top">
                {t('invoice-choose-us-section-heading')}
                </div>
                 <div className="invoice-choose-us-section-bottom">
                    <div >
                    <img src="\images\pre-built-gst-templates.png" alt=""/> {t('invoice-choose-us-section-box1.line1')}
                        <p>{t('invoice-choose-us-section-box1.line2')}</p>
                    </div>
                    <div>
                    <img src="\images\real-time-tax-calculation.png" alt=""/> {t('invoice-choose-us-section-box2.line1')} 
                        <p>{t('invoice-choose-us-section-box2.line2')}</p>
                    </div>
                    <div>
                    <img src="\images\seamless-customization.png" alt=""/> {t('invoice-choose-us-section-box3.line1')}
                    <p>{t('invoice-choose-us-section-box3.line2')}</p>
                    </div>
                    <div>
                    <img src="\images\multiple-formats.png" alt=""/> {t('invoice-choose-us-section-box4.line1')}
                    <p>{t('invoice-choose-us-section-box4.line2')}</p>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default InvoiceChooseUsSection;